import { render, staticRenderFns } from "./JobCreateUpdate.vue?vue&type=template&id=622b7398&scoped=true&"
import script from "./JobCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./JobCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./JobCreateUpdate.vue?vue&type=style&index=0&id=622b7398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b7398",
  null
  
)

export default component.exports